import { getQuestions } from '../pages/Journal/journalSlice';
import { refreshToken, setLoginInfo } from '../pages/Login/loginSlice';
import { showCheckIn, showLoading } from '../pages/tabs/tabsSlice';
import { useAppDispatch } from '../store';
import { useCapturePostHog } from './useCapturePostHog';

export const useTakeJournal = () => {
  const dispatch = useAppDispatch();
  const { capturePostHogCustomEvent } = useCapturePostHog();

  const takeJournal = async (product_id: string | null, componentName: string) => {
    dispatch(setLoginInfo(null));
    dispatch(showLoading(true));
    await dispatch(getQuestions(product_id));
    // new web token rule
    await dispatch(refreshToken({ history: null, isJournaling: true })); //no need to pass history
    dispatch(showCheckIn());
    dispatch(showLoading(false));
    capturePostHogCustomEvent(`${componentName} takeJournal`, {
      product_id,
    });
  };

  return { takeJournal };
};
